/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateNotificationSettingsRequestSettings } from './UpdateNotificationSettingsRequestSettings';
import {
    UpdateNotificationSettingsRequestSettingsFromJSON,
    UpdateNotificationSettingsRequestSettingsFromJSONTyped,
    UpdateNotificationSettingsRequestSettingsToJSON,
    UpdateNotificationSettingsRequestSettingsToJSONTyped,
} from './UpdateNotificationSettingsRequestSettings';

/**
 * Payload to update notification settings
 * @export
 * @interface UpdateNotificationSettingsRequest
 */
export interface UpdateNotificationSettingsRequest {
    /**
     * 
     * @type {UpdateNotificationSettingsRequestSettings}
     * @memberof UpdateNotificationSettingsRequest
     */
    settings: UpdateNotificationSettingsRequestSettings;
}

/**
 * Check if a given object implements the UpdateNotificationSettingsRequest interface.
 */
export function instanceOfUpdateNotificationSettingsRequest(value: object): value is UpdateNotificationSettingsRequest {
    if (!('settings' in value) || value['settings'] === undefined) return false;
    return true;
}

export function UpdateNotificationSettingsRequestFromJSON(json: any): UpdateNotificationSettingsRequest {
    return UpdateNotificationSettingsRequestFromJSONTyped(json, false);
}

export function UpdateNotificationSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNotificationSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'settings': UpdateNotificationSettingsRequestSettingsFromJSON(json['settings']),
    };
}

export function UpdateNotificationSettingsRequestToJSON(json: any): UpdateNotificationSettingsRequest {
    return UpdateNotificationSettingsRequestToJSONTyped(json, false);
}

export function UpdateNotificationSettingsRequestToJSONTyped(value?: UpdateNotificationSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'settings': UpdateNotificationSettingsRequestSettingsToJSON(value['settings']),
    };
}

